<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "../../components/loader";
import api from "@/axios";
import moment from "moment";
import exportFromJSON from "export-from-json";
import Swal from 'sweetalert2';
import {getBaseUrl} from "@/helpers/baseUrl";
import Multiselect from "@vueform/multiselect";

export default {
  page: {
    title: "Fretes",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    Multiselect,
  },
  data() {
    return {
      title: "Fretes",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Fretes",
          active: true,
        },
      ],

      updating: true,
      qtdItens: 0,
      valorFretes: 0,
      dentroPrazo: 0,
      foraPrazo: 0,
      dentroPrazoNaoEntregue: 0,
      foraPrazoNaoEntregue: 0,
      entregaHoje: 0,
      semPrevisao: 0,
      semCteEmit: 0,
      quantFrete: 0,
      sttFinali: 0,
      sttElabor: 0,
      contCota: 0,
      contCotaVol: 0,
      eficEntrega: 0,
      custoFrete: 0,
      ticketMedio: 0,
      contaCte: 0,
      dentroPrazoNaoEntregueValor: 0,
      foraPrazoNaoEntregueValor: 0,
      dentroPrazoValor: 0,
      foraPrazoValor: 0,
      eficEntregAnt: 0,
      percCustoFrete: 0,
      percTicketM: 0,
      percFreteMes: 0,
      valorAcuCarga: 0,
      valorNotasFiscais: 0,
      numeroCotacoes: 0,
      chartFretePrazo: null,
      ocorrenciaSum: null,
      ocorrenciaExport: null,
      showModalPeriodo: false,
      dtFimFormated: null,
      dtIniFormated: null,
      dtIniFiltro: null,
      dtIniFiltroFormated: null,
      dtFimFiltroFormated: null,
      dtFimFiltro: null,
      submittedPeriodo: null,
      reloadTime: 0,
      exibEmit: true,
      exibDest: false,
      exibAmbos: false,
      excluirTransp: [],
      listaTranspDisponiveis: [],
      submitted: false,
      preferencias: null,
      showModalBoasVindas: false,
      userLogged: {},

      slaTopCincoEstados: null,

      showModalUpgradePlano: false,
      planosData: [
        {
          id: 'tms_free',
          nome: 'TMS Free',
          text: 'Grátis / Limitado',
          icon: 'bx-walk',
          valor: 0.00,
          itens: ['1 usuário', 'Até 1 tabela de frete', 'Até 100 cotações mês', 'Até 20 contratações mês', 'Suporte E-mail']
        },
        {
          id: 'tms_plus',
          nome: 'TMS Plus',
          text: '',
          icon: 'bx-run',
          valor: 499.00,
          itens: ['5 usuários', 'Até 5 tabelas de frete', 'Rastreamento básico', 'Até 2.000 cotações mês', 'Até 500 contratações mês', 'Suporte Online']
        },
        {
          id: 'tms_enterprise',
          nome: 'TMS Enterprise',
          text: '',
          icon: 'bx-cycling',
          valor: 1499,
          itens: ['10 usuários', 'Até 10 tabelas de frete', 'Rastreamento avançado com e-mail', 'Cotações ilimitadas', 'Contratações ilimitadas', 'Suporte Online']
        },
        {
          id: 'tms_pro',
          nome: 'TMS Pro',
          text: 'Entre em contato',
          icon: 'bx-car',
          valor: 'Sob Consulta',
          itens: ['Usuários ilimitados', 'Até 15 tabelas (negociação pelo time econoPRO)', 'Rastreamento avançado com e-mail e Whatsapp', 'Cotações ilimitadas', 'Contratações ilimitadas', 'Suporte humanizado (profissional dedicado)']
        }
      ],
      planoAtualData: {},
      showFormModal: false,
      formIndex: 0,
      formDeny: false,
      formData: [
        {
          label: 'Qual é o porte da sua empresa?',
          value: "",
          otherText: "",
          options: [
            'Autônomo / MEI',
            'Pequena (até 20 colaboradores)',
            'Média (21 a 100 colaboradores)',
            'Grande (acima de 100 colaboradores)',
            'Outro'
          ]
        },
        {
          label: 'Qual é o seu principal papel dentro da empresa?',
          value: "",
          otherText: "",
          options: [
            'Dono(a) / Sócio(a)',
            'Gestor(a) de logística / operações',
            'Financeiro / administrativo',
            'Motorista / operador',
            'Outro'
          ]
        },
        {
          label: 'Como você realiza hoje o gerenciamento de fretes e entregas?',
          value: "",
          otherText: "",
          options: [
            'Planilhas manuais',
            'Sistema próprio',
            'Sistema contratado (TMS, ERP, etc.)',
            'Outro'
          ]
        },
        {
          label: 'Qual o maior desafio da sua operação atualmente?',
          value: "",
          otherText: "",
          options: [
            'Reduzir custos de frete',
            'Controlar prazos e rotas',
            'Ter mais visibilidade dos processos',
            'Integração entre setores (financeiro, estoque, logística)',
            'Outro'
          ]
        },
        {
          label: 'Com que frequência sua empresa lida com transporte/fretes?',
          value: "",
          otherText: "",
          options: [
            'Todos os dias',
            'Algumas vezes por semana',
            'Algumas vezes por mês',
            'Raramente',
            'Outro'
          ]
        },
        {
          label: 'Você gostaria de receber conteúdos práticos para otimizar sua operação?',
          value: "",
          options: [
            'Sim, quero dicas e materiais gratuitos',
            'Apenas informações essenciais do sistema'
          ]
        }
      ],
      userFormId: 0
    };
  },

  created() {
    this.dtIniFiltro = moment().subtract(30,'days').startOf('day').format('YYYY-MM-DD 00:00:00');
    this.dtFimFiltro = moment().endOf('day').format('YYYY-MM-DD 23:59:59');
  },

  methods: {
    ofereceUpdate(){
      console.log('ofereceUpdate')

      if(this.userLogged.tipo === 'tms_free'){
        this.showModalUpgradePlano = true
      }
    },

    upgradePlano(){
      console.log('upgradePlano')
      this.showModalUpgradePlano = false
      this.$router.push('/usuario/perfil/' + this.userLogged.id)
    },

    naoExibirBoasVindas(){
      console.log('naoExibirBoasVindas');
      this.showModalBoasVindas = false;
      localStorage.setItem('preferencias', JSON.stringify({
        'exboasvpct': false
      }))
    },


    totalEntregue() {
      const dentro = isNaN(Number(this.dentroPrazo)) ? 0 : Number(this.dentroPrazo);
      const fora = isNaN(Number(this.foraPrazo)) ? 0 : Number(this.foraPrazo);
      return dentro + fora;
    },

    totalEmTransito(){
      const dentro = isNaN(Number(this.dentroPrazoNaoEntregue)) ? 0 : Number(this.dentroPrazoNaoEntregue);
      const fora = isNaN(Number(this.foraPrazoNaoEntregue)) ? 0 : Number(this.foraPrazoNaoEntregue);
      return dentro + fora; 
    },

    handleCheckbox(checkbox){
      if (checkbox === 'exibEmit'){
        this.exibDest = false;
        this.exibAmbos = false;
      }else if(checkbox === 'exibDest') {
        this.exibEmit = false;
        this.exibAmbos = false;
      }else if(checkbox === 'exibAmbos') {
        this.exibEmit = false;
        this.exibDest = false;
      }else if(checkbox !== 'exibEmit' && checkbox !== 'exibDest' && checkbox !== 'exibAmbos'){
        this.exibEmit = false;
        this.exibDest = false;
        this.exibAmbos = true;
      }

      this.excluirTransp = [];
      this.listaTranspDisponiveis = [];
      this.atualizaDataList();
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))

      this.showModalPeriodo = false
      this.excluirTransp = [];
      this.listaTranspDisponiveis = [];
      this.atualizaDataList()
    },

    atualizaDataList(){
      console.log("atualizaDataList");
      this.updating = true

      const filtros = JSON.parse(localStorage.getItem("filtros"))

      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro){
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const exibEmit = this.exibEmit
      const exibDest = this.exibDest
      const exibAmbos = this.exibAmbos
      const di = this.dtIniFiltro
      const df = this.dtFimFiltro
      const paramsReq = {
        'ee': exibEmit,
        'ed': exibDest,
        'ea': exibAmbos,
        'di': di,
        'df': df,
        'excluir': this.excluirTransp,
      }

      try{
        api.get(`${getBaseUrl()}api/indexfretenova`, {
          params: paramsReq
        }).then((res) => {
          console.log("response");
          console.log(res);
          //console.log(JSON.stringify(res.data));

          this.userFormId = res.data.userFormId
          console.log('userFormId: ' + this.userFormId)

          this.trataRetorno(res);
          this.updating = false

          this.preferencias = JSON.parse(localStorage.getItem('preferencias'))
          console.log('this.preferencias_0')
          console.log(this.preferencias)
          if (!this.preferencias) {
            console.log('this.preferencias_0_nao_existe')
            localStorage.setItem('preferencias', JSON.stringify({
              'exboasvpct': true
            }))
          }
          this.preferencias = JSON.parse(localStorage.getItem('preferencias'))

          console.log('this.preferencias_1')
          console.log(this.preferencias)
          //DESABILITEI O MODAL DE BOAS VINDAS PARA SER EXIBIDO APENAS UMA VEZ APÓS O FORMULÁRIO
          /*if (this.preferencias && this.preferencias.exboasvpct && this.preferencias.exboasvpct === true) {
            this.showModalBoasVindas = true
          }*/

          this.userLogged = JSON.parse(localStorage.getItem('user'))
          let tipo = this.userLogged.tipo

          if(tipo.includes('tms_') && (this.userFormId == 0 || this.userFormId == null)){
            console.log('entrou no formulario início')
            this.showFormModal = true
          }
        });
      }catch(error){
        console.log('Erro método atualizaDataList: '+ error);
      }
      // this.showFormModal = true
    },

    trataRetorno(res) {
      console.log('trataRetorno');

      if(res.status === 204){
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Não há nenhum registro conforme parametro enviado!",
          showConfirmButton: false,
          timer: 5000
        });

      }else{
        if (typeof res.data.dtIniFiltro === 'string' && typeof res.data.dtFimFiltro === 'string') {
          this.dtIniFormated = res.data.dtIniFiltro.split('-');
          this.dtIniFormated = `${this.dtIniFormated[2].substr(0,2)}/${this.dtIniFormated[1]}/${this.dtIniFormated[0]}`;

          this.dtFimFormated = res.data.dtFimFiltro.split('-');
          this.dtFimFormated = `${this.dtFimFormated[2].substr(0,2)}/${this.dtFimFormated[1]}/${this.dtFimFormated[0]}`;

          this.title = `Fretes: ${this.dtIniFormated} - ${this.dtFimFormated}`;

          this.totalizadores = res.data.totalizadores

          this.qtdItens = this.totalizadores.quantFrete + this.totalizadores.contacte;

          this.valorFretes = res.data.totalizadores.totalfrete,
          this.dentroPrazoNaoEntregue = res.data.totalizadores.dentroPrazoNaoEntregue,
          this.foraPrazoNaoEntregue = res.data.totalizadores.foraPrazoNaoEntregue,
          this.dentroPrazo = res.data.totalizadores.dentroprazo,
          this.foraPrazo = res.data.totalizadores.foraprazo,
          this.contCota = res.data.totalizadores.contcota,
          this.contCotaVol = res.data.totalizadores.contcotavol,
          this.eficEntrega = res.data.totalizadores.eficentrega,
          this.custoFrete = res.data.totalizadores.custofrete,
          this.ticketMedio =  res.data.totalizadores.ticketmedio,
          this.contaCte =  res.data.totalizadores.contacte,
          this.dentroPrazoNaoEntregueValor = res.data.totalizadores.dentroPrazoNaoEntregueValor,
          this.foraPrazoNaoEntregueValor = res.data.totalizadores.foraPrazoNaoEntregueValor,
          this.dentroPrazoValor =  res.data.totalizadores.dentroprazovalor,
          this.foraPrazoValor =  res.data.totalizadores.foraprazovalor,
          this.valorAcuCarga =  res.data.totalizadores.valoracucarga,
          this.valorNotasFiscais =  res.data.totalizadores.valornotas,
          this.numeroCotacoes =  res.data.totalizadores.numerocotacoes,

          this.entregaHoje = res.data.totalizadores.entregahoje,
          this.semPrevisao = res.data.totalizadores.semprevisao,
          this.semCteEmit = res.data.totalizadores.semcteemit,
          this.quantFrete = res.data.totalizadores.quantfrete,
          this.sttFinali = res.data.totalizadores.sttfinali,
          this.sttElabor = res.data.totalizadores.sttelabor,
          this.eficEntregAnt = res.data.totalizadores.eficentregant,
          this.percCustoFrete = res.data.totalizadores.perccustofrete,
          this.percTicketM = res.data.totalizadores.percticketm,
          this.percFreteMes = res.data.totalizadores.percfretemes,

          this.slaTopCincoEstados = res.data.slaTopCincoEstados

          this.ocorrenciaSum = res.data.ocorrenciaSum
          this.ocorrenciaExport = res.data.ocorrenciaExport

          if (this.listaTranspDisponiveis.length === 0 && Array.isArray(res.data.transpList)) {
            this.listaTranspDisponiveis = res.data.transpList
              .map(t => ({ value: t.cnpj, label: t.nome }));
          }

          this.chartFretePrazo = {
            series: [],
            chartOptions: {
              chart: {
                type: 'donut',
                height: 240,
              },
              labels: ['Dentro do Prazo', 'Fora do Prazo', 'Dentro do Prazo(Em Trânsito)', 'Fora do Prazo(Em Trânsito)'],
              colors: [ '#556ee6','#f6c832', '#34c38f', '#f46a6a'],
              legend: {
                show: false,
              },
              plotOptions: {
                pie: {
                  donut: {
                    size: '70%',
                  }
                }
              }
            }
          }

          if (typeof this.dentroPrazo !== 'number' || typeof this.foraPrazo !== 'number' || typeof this.dentroPrazoNaoEntregue !== 'number' || typeof this.foraPrazoNaoEntregue !== 'number') {
            this.dentroPrazo = 0;
            this.foraPrazo = 0;
            this.dentroPrazoNaoEntregue = 0;
            this.foraPrazoNaoEntregue = 0;


          }

          if (this.dentroPrazo === 0 && this.foraPrazo === 0 && this.dentroPrazoNaoEntregue ===0 && this.foraPrazoNaoEntregue === 0) {
            this.chartFretePrazo.series = null;
          } else {
            if (this.dentroPrazo === 0) {
              this.chartFretePrazo.series = [this.foraPrazo, this.dentroPrazoNaoEntregue, this.foraPrazoNaoEntregue];
            } else if (this.foraPrazo === 0) {
              this.chartFretePrazo.series = [this.dentroPrazo, this.dentroPrazoNaoEntregue, this.foraPrazoNaoEntregue];
            } else if (this.dentroPrazoNaoEntregue === 0) {
              this.chartFretePrazo.series = [this.dentroPrazo, this.foraPrazo, this.foraPrazoNaoEntregue];
            } else if (this.foraPrazoNaoEntregue === 0) {
              this.chartFretePrazo.series = [this.dentroPrazo, this.foraPrazo, this.dentroPrazoNaoEntregue];
            }



            else {
              this.chartFretePrazo.series = [this.dentroPrazo, this.foraPrazo, this.dentroPrazoNaoEntregue, this.foraPrazoNaoEntregue];
            }
          }

        } else {
          console.error('Formato de data inválido:', res.data.dtIniFiltro, res.data.dtFimFiltro);
        }
      }
    },

    exportExcel() {
      const data = this.ocorrenciaExport;
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data.length > 0) {
        exportFromJSON({data, fileName, exportType});
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Excel gerado com sucesso",
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          window.location.reload();
        });
      }
    },

    productSelling(event) {
      switch (event.target.value) {
        case "marco":
          this.products = [
            {
              title: "Região 001",
              amount: "R$ 784.285,00",
              revenue: "0.4",
              list: [
                {
                  name: "Região 099",
                  text: "descrição auxiliar região",
                  sales: 41,
                  color: "#f46a6a",
                },
                {
                  name: "Região 055",
                  text: "descrição auxiliar região",
                  sales: 14,
                  color: "#556ee6",
                },
                {
                  name: "Região 987",
                  text: "descrição auxiliar região",
                  sales: 85,
                  color: "#34c38f",
                },
              ],
            },
          ];
          break;
        case "fevereiro":
          this.products = [
            {
              title: "Região 002",
              amount: "R$ 638.855,00",
              revenue: "0.6",
              list: [
                {
                  name: "Região 002",
                  text: "descrição auxiliar região",
                  sales: 37,
                  color: "#556ee6",
                },
                {
                  name: "Região 001",
                  text: "descrição auxiliar região",
                  sales: 72,
                  color: "#f46a6a",
                },
                {
                  name: "Região 888",
                  text: "descrição auxiliar região",
                  sales: 54,
                  color: "#34c38f",
                },
              ],
            },
          ];
          break;
        case "janeiro":
          this.products = [
            {
              title: "Região 888",
              amount: "R$ 474.000,55",
              revenue: "0.8",
              list: [
                {
                  name: "Região 077",
                  text: "descrição auxiliar região",
                  sales: 31,
                  color: "#34c38f",
                },
                {
                  name: "Região 444",
                  text: "descrição auxiliar região",
                  sales: 20,
                  color: "#556ee6",
                },
                {
                  name: "Região 005",
                  text: "descrição auxiliar região",
                  sales: 40,
                  color: "#f46a6a",
                },
              ],
            },
          ];
          break;
        case "dezembro":
          this.products = [
            {
              title: "Região 099",
              amount: "R$ 874.500,00",
              revenue: "0.4",
              list: [
                {
                  name: "Região 005",
                  text: "descrição auxiliar região",
                  sales: 41,
                  color: "#f46a6a",
                },
                {
                  name: "Região 999",
                  text: "descrição auxiliar região",
                  sales: 74,
                  color: "#34c38f",
                },
                {
                  name: "Região 006",
                  text: "descrição auxiliar região",
                  sales: 52,
                  color: "#556ee6",
                },
              ],
            },
          ];
          break;
        default:
          this.products = [
            {
              title: "Região 002",
              amount: "R$ 638.500,00",
              revenue: "0.6",
              list: [
                {
                  name: "Região 002",
                  text: "descrição auxiliar região",
                  sales: 37,
                },
                {
                  name: "Região 001",
                  text: "descrição auxiliar região",
                  sales: 72,
                },
                {
                  name: "Região 888",
                  text: "descrição auxiliar região",
                  sales: 54,
                },
              ],
            },
          ];
          break;
      }
    },

    monthlyEarning(event) {
      switch (event.target.value) {
        case "marco":
          this.earnings = [
            {
              name: "Março",
              amount: "R$ 240.530,35",
              revenue: "0.4",
              time: "do período anterior",
              month: "Último mês",
              previousamount: "R$ 220.810,04",
              series: [
                {
                  name: "series1",
                  data: [31, 40, 36, 51, 49, 72, 69, 56, 68, 82, 68, 76],
                },
              ],
            },
          ];
          break;
        case "fevereiro":
          this.earnings = [
            {
              name: "Fevereiro",
              amount: "R$ 288.700,35",
              revenue: "0.4",
              time: "do período anterior",
              month: "Último mês",
              previousamount: "R$ 684.100,04",
              series: [
                {
                  name: "series1",
                  data: [28, 30, 48, 50, 47, 40, 35, 48, 56, 42, 65, 41],
                },
              ],
            },
          ];
          break;

        case "janeiro":
          this.earnings = [
            {
              name: "Janeiro",
              amount: "R$ 210.000,35",
              revenue: "0.4",
              time: "do período anterior",
              month: "Último mês",
              previousamount: "R$ 674.870,04",
              series: [
                {
                  name: "series1",
                  data: [28, 48, 39, 47, 58, 46, 38, 47, 30, 40, 70, 42],
                },
              ],
            },
          ];
          break;

        case "dezembro":
          this.earnings = [
            {
              name: "Dezembro",
              amount: "R$ 245.530,35",
              revenue: "0.4",
              time: "do período anterior",
              month: "Último mês",
              previousamount: "R$ 228.100,04",
              series: [
                {
                  name: "series1",
                  data: [31, 40, 36, 51, 49, 72, 69, 56, 68, 82, 68, 76],
                },
              ],
            },
          ];
          break;

        default:
          this.earnings = [
            {
              name: "This month",
              amount: "$2453.35",
              revenue: "0.4",
              time: "From previous period",
              month: "Last month",
              previousamount: "$2281.04",
              series: [
                {
                  name: "series1",
                  data: [31, 40, 36, 51, 49, 72, 69, 56, 68, 82, 68, 76],
                },
              ],
            },
          ];
      }
    },

    formSubmit(e) {
      console.log('formSubmit')
      console.log(e)

      this.submitted = true;

      // stop here if form is invalid
      this.v$.$touch();

      if (this.v$.$invalid) {
        return;
      } else {
        const id = this.ChatData.length;
        const message = this.chat.message;
        const currentDate = new Date();
        this.ChatData.push({
          id: id + 1,
          align: "right",
          name: "Usuário Testes 0099",
          message,
          time: currentDate.getHours() + ":" + currentDate.getMinutes(),
        });
        this.handleScroll();
      }
      this.submitted = false;
      this.chat = {};
    },

    handleScroll() {
      if (this.$refs.current.$el) {
        setTimeout(() => {
          this.$refs.current.SimpleBar.value.getScrollElement().scrollTop =
              this.$refs.current.SimpleBar.value.getScrollElement().scrollHeight + 1500;
        }, 500);
      }
    },

    nomeUF(value) {
      let estado = 'Não Existe'
      switch (value) {
        case 'AC':
          estado = 'Acre'
          break
        case 'AL':
          estado = 'Alagoas'
          break
        case 'AP':
          estado = 'Amapá'
          break
        case 'AM':
          estado = 'Amazonas'
          break
        case 'BA':
          estado = 'Bahia'
          break
        case 'CE':
          estado = 'Ceará'
          break
        case 'DF':
          estado = 'Distrito Federal'
          break
        case 'ES':
          estado = 'Espírito Santo'
          break
        case 'GO':
          estado = 'Goiás'
          break
        case 'MA':
          estado = 'Maranhão'
          break
        case 'MT':
          estado = 'Mato Grosso'
          break
        case 'MS':
          estado = 'Mato Grosso do Sul'
          break
        case 'MG':
          estado = 'Minas Gerais'
          break
        case 'PA':
          estado = 'Pará'
          break
        case 'PB':
          estado = 'Paraíba'
          break
        case 'PR':
          estado = 'Paraná'
          break
        case 'PE':
          estado = 'Pernambuco'
          break
        case 'PI':
          estado = 'Piauí'
          break
        case 'RJ':
          estado = 'Rio de Janeiro'
          break
        case 'RN':
          estado = 'Rio Grande do Norte'
          break
        case 'RS':
          estado = 'Rio Grande do Sul'
          break
        case 'RO':
          estado = 'Rondônia'
          break
        case 'RR':
          estado = 'Roraima'
          break
        case 'SC':
          estado = 'Santa Catarina'
          break
        case 'SP':
          estado = 'São Paulo'
          break
        case 'SE':
          estado = 'Sergipe'
          break
        case 'TO':
          estado = 'Tocantins'
          break
      }
      return estado
    },

    formatDecimal(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatInteger(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    sendRegisterForm() {
      if (["", false].includes(this.formData[this.formIndex].value)) {
        this.formDeny = true
        return
      }

      console.log('---sendRegisterForm---')
      const payload = this.formData.map(field => ({
        label: field.label,
        value: field.value === 'Outro' ? field.otherText : field.value
      }))
      console.log('Payload:', payload)

      api.post(`${getBaseUrl()}api/submitformpct`, { data: payload })
        .then(response => {
          if (response.data) {
            Swal.fire({
              title: 'Obrigado por preencher o formulário!',
              text: 'Seu feedback é muito importante para nós.',
              icon: 'success',
              showConfirmButton: false,
              timer: 2500
            })
          }
        }).then(() => {
          this.showFormModal = false
          this.$router.push('/dashboard/fretes')
          this.showModalBoasVindas = true
        })
        .catch(error => {
          console.error('Submission error:', error)
          Swal.fire({
            title: 'Erro ao enviar formulário',
            text: 'Error code: ' + (error.response ? error.response.status : 'Network Error'),
            icon: 'error',
            confirmButtonText: 'OK'
          })
        })
    },

    nextQuestion() {
      const currentQuestion = this.formData[this.formIndex]
      if (
        ["", false].includes(currentQuestion.value) ||
        (
          currentQuestion.value === "Outro" && 
          ["", false].includes(currentQuestion.otherText) 
        ) 
      ) {
        this.formDeny = true
        return
      }

      console.log(currentQuestion)
      this.formDeny = false
      this.formIndex += 1
    }
  },
  mounted() {
    console.log('mounted_dashFrete_0')

    this.atualizaDataList();
    console.log('...')
    // this.userLogged = JSON.parse(localStorage.getItem('user'))
  },
};
</script>


<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo=true" />

    <b-alert show dismissible
             v-if="!updating && userLogged && userLogged.tipo && userLogged.tipo.includes('tms_')"
             variant="info">
      <a class="dropdown-item "
         @click="upgradePlano"
         href="javascript: void(0);">
        <i class="mdi mdi-alert me-2"></i>Seu plano atual possui limitações, para acessar todos os recursos da plataforma <span class="text-warning">clique aqui e faça upgrade agora mesmo.<i class="mdi mdi-rocket-launch ms-2"></i> </span>
      </a>
    </b-alert>


    <div v-if="(qtdItens == 0 || qtdItens == null) && !updating" class="alert alert-danger" role="alert">
      Não existe informações para o período informado
    </div>

    <Loader v-if="updating" style="min-height: 110px;">
    </Loader>

    <div class="row" v-if="!updating">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-2">
                <div class="d-flex">
                  <div class="me-3">
                    <img
                        src="@/assets/images/truck03.png"
                        alt
                        class="avatar-md rounded-circle img-thumbnail"
                    />
                  </div>

                  <div class="flex-grow-1 align-self-center">
                    <div class="text-muted">
                      <p class="mb-2">Valor de Fretes</p>
                      <h5 class="mb-1">R$ {{ formatDecimal(valorFretes) }}</h5>
                    </div>
                    <br>
                    <div class="text-muted">
                      <p class="mb-2">Valor de Carga</p>
                      <h5 class="mb-1">R$ {{ formatDecimal(valorAcuCarga) }}</h5>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-7  mt-4 mt-lg-0 align-self-center">
                <div class="row">
                  <div class="col-3">
                    <div>
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <p class="mb-0 font-size-16">Entregue</p>
                        <span class="badge font-size-14 mb-1" style=" background-color: #f0f0f0; color: #333; min-width: 8ch; text-align: center; padding: 4px 10px; border-radius: 8px; " >
                            {{ formatInteger(totalEntregue()) }}
                        </span>
                      </div>

                      <div class="d-flex justify-content-between">
                        <div class="text-muted">
                          <p class="font-size-15 mb-1">Dentro do Prazo:</p>
                          <p class="font-size-15">Fora do Prazo:</p>
                        </div>
                        <div class="text-center">
                          <span class="badge badge-soft-success font-size-14 mb-1" style="min-width: 8ch;" >
                              {{ formatInteger(dentroPrazo) }}
                          </span>
                          <br />
                          <span class="badge badge-soft-danger font-size-14" style="min-width: 8ch;" >
                              {{ formatInteger(foraPrazo) }}
                          </span>
                        </div>
                    </div>
                  </div>
                </div>

                  <div class="col-3" style="margin-left: 5px;">
                    <div>
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <p class="mb-0 font-size-16">Em Trânsito</p>
                        <span class="badge font-size-14 mb-1" style=" background-color: #f0f0f0; color: #333; min-width: 8ch; text-align: center; padding: 4px 10px; border-radius: 8px; " >
                            {{ formatInteger(totalEmTransito()) }}
                        </span>
                      </div>
                      <div class="d-flex justify-content-between">
                          <div class="text-muted">
                            <p class="font-size-15 mb-1">Dentro do Prazo:</p>
                            <p class="font-size-15">Fora do Prazo:</p>
                          </div>
                        <div class="text-center">
                          <span class="badge badge-soft-success font-size-14 mb-1" style="min-width: 8ch;" >
                              {{ formatInteger(dentroPrazoNaoEntregue) }}
                          </span>
                          <br />
                          <span class="badge badge-soft-danger font-size-14" style="min-width: 8ch;" >
                              {{ formatInteger(foraPrazoNaoEntregue) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-4 text-lg-center">
                    <div>
                      <div class="d-flex justify-content-center">
                        <div class="col-8 text-start" style="margin-left: 15px">
                          <p class="font-size-16">Entrega Hoje: </p>
                          <p class="font-size-16" style=" margin-top: 5px">Sem Previsão: </p>
                          <p class="font-size-16" style=" margin-top: 5px">Sem CTe Emitido: </p>
                        </div>
                        <div class="col-3 text-lg-center">
                          <span class="badge badge-soft-info font-size-16 " style="min-width: 8ch; margin-top: 0px">
                                {{ formatInteger(entregaHoje) }}
                          </span>
                          <span class="badge badge-soft-danger font-size-16" style="min-width: 8ch; margin-top: 15px">
                              {{ formatInteger(semPrevisao) }}
                          </span>
                          <span class="badge badge-soft-warning font-size-16" style="min-width: 8ch; margin-top: 15px">
                              {{ formatInteger(semCteEmit) }}
                          </span>
                        </div >
                      </div>
                    </div>
                  </div>
                  <!--                  <div class="col-2 text-lg-center">-->
                  <!--                    <div>-->
                  <!--                      <p class="text-muted text-truncate mb-2 font-size-14">Entrega Hoje</p>-->
                  <!--                      <br>-->
                  <!--                      <span class="badge badge-soft-info font-size-16">-->
                  <!--                              {{ formatInteger(entregaHoje) }} <span class="font-size-12"></span>-->
                  <!--                            </span>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <!--                  <div class="col-2 text-lg-center">-->
                  <!--                    <div>-->
                  <!--                      <p class="text-muted text-truncate mb-2 font-size-14">Sem Previsão</p>-->
                  <!--                      <br>-->
                  <!--                      <span class="badge badge-soft-warning font-size-16">-->
                  <!--                              {{ formatInteger(semPrevisao) }} <span class="font-size-12"></span>-->
                  <!--                            </span>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <!--                  <div class="col-2 text-lg-center">-->
                  <!--                    <div>-->
                  <!--                      <p class="text-muted text-truncate mb-2 font-size-14">Sem CTe Emitido</p>-->
                  <!--                      <br>-->
                  <!--                      <span class="badge badge-soft-primary font-size-16">-->
                  <!--                              {{ formatInteger(semCteEmit) }} <span class="font-size-12"></span>-->
                  <!--                            </span>-->
                  <!--                    </div>-->
                  <!--                  </div>-->

                  <div class="col-1 " style="float:left; max-width:200px;max-height:200px;margin-left:70px; border-left:1px solid #c5c6ca" ></div>

                </div>
              </div>

              <div class="col-lg-2 text-lg-center mt-4 mt-lg-0 align-self-center">
                <div class="row">
                  <div class=" justify-content-center" >
                    <p class="badge badge-soft-primary text-truncate mb-2 font-size-16" style="margin-top: -7px">Status de Romaneios</p>
                    <div class="row justify-content-center" style="margin-top: 7px">
                      <div class="col-5" >
                        <span class=" text-muted font-size-14">Em aberto: </span>
                        <span class="badge badge-soft-warning font-size-16">{{ formatInteger(sttElabor) }}</span>
                      </div>
                      <div class ="col-5">
                        <span class=" text-muted font-size-14">Finalizado: </span>
                        <span class="badge badge-soft-success font-size-16">{{ formatInteger(sttFinali) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-1 align-self-center d-none d-lg-block d-flex justify-content-end">
                <div class="clearfix mt-4 mt-lg-0">
                  <b-dropdown
                      class="float-end"
                      right
                      variant="primary"
                      menu-class="dropdown-menu-end"
                  >
                    <template v-slot:button-content>
                      <i class="bx bx-filter-alt search-icon align-middle me-1"></i> Filtro
                    </template>
                    <b-dropdown-item > <span class=" font-size-14">Emitente</span>
                      <b-form-checkbox
                          switch size="lg"
                          :value="true"
                          :unchecked-value="false"
                          @change="handleCheckbox('exibEmit')"
                          v-model="exibEmit">
                        <span class=" font-size-12">{{ exibEmit === true ? 'Sim' : 'Não' }}</span>
                      </b-form-checkbox> </b-dropdown-item>

                    <b-dropdown-item > <span class=" font-size-14">Destinatário</span>
                      <b-form-checkbox
                          switch size="lg"
                          :value="true"
                          :unchecked-value="false"
                          @change="handleCheckbox('exibDest')"
                          v-model="exibDest">
                        <span class=" font-size-12">{{ exibDest === true ? 'Sim' : 'Não' }}</span>
                      </b-form-checkbox> </b-dropdown-item>

                    <b-dropdown-item > <span class=" font-size-14">Ambos</span>
                      <b-form-checkbox
                          switch size="lg"
                          :value="true"
                          :unchecked-value="false"
                          @change="handleCheckbox('exibAmbos')"
                          v-model="exibAmbos">
                        <span class=" font-size-12">{{ exibAmbos === true ? 'Sim' : 'Não' }}</span>
                      </b-form-checkbox> </b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>

                    <b-dropdown-form style="min-width: 32ch">
                      <span class="font-size-13 d-block mb-1">Ignorar transportadora:</span>
                      <multiselect
                          v-model="excluirTransp"
                          mode="tags"
                          value-prop="value"
                          label="label"
                          :options="listaTranspDisponiveis"
                          placeholder="Selecione para ignorar..."
                          :close-on-select="false"
                          :searchable="true"
                          @change="(val) => { excluirTransp = val; atualizaDataList(); }"
                      />
                    </b-dropdown-form>
                  </b-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Loader class="mt-4" v-if="updating" style="min-height: 150px;">
    </Loader>

    <div class="row" v-if="!updating">
      <div class="col-xl-12">
        <div class="row">

          <div class="col-sm-3">
            <div class="card">
              <div class="card-body text-center">
                <div class="d-flex align-items-center justify-content-center mb-3">
                  <div class="avatar-xs me-2">
                    <span class="avatar-title rounded-circle bg-soft bg-primary text-primary" style="font-size: 20px;">
                      <i class="bx bx-file"></i>
                    </span>
                  </div>
                  <h5 class="font-size-14 mb-0">Quantidade de NFs</h5>
                </div>
                <div style="background-color: #f8f9fa; padding: 12px 16px; border-radius: 8px; display: inline-block;">
                  <h1 class="mb-1 fw-semibold">{{ formatInteger(quantFrete) }}</h1>
                  <span class="text-muted" style="font-size: 13px;">Notas fiscais emitidas</span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-3">
            <div class="card">
              <div class="card-body text-center">
                <div class="d-flex align-items-center justify-content-center mb-3">
                  <div class="avatar-xs me-2">
                    <span class="avatar-title rounded-circle bg-soft bg-primary text-primary" style="font-size: 20px;">
                      <i class="bx bx-file-find"></i>
                    </span>
                  </div>
                  <h5 class="font-size-14 mb-0">Quantidade de CTEs</h5>
                </div>

                <div style="background-color: #f8f9fa; padding: 12px 16px; border-radius: 8px; display: inline-block;">
                  <h1 class="mb-1 fw-semibold">{{ formatInteger(contaCte) }}</h1>
                  <span class="text-muted" style="font-size: 13px;">CTEs emitidos</span>
                </div>

              </div>
            </div>
          </div>
          
          <div class="col-sm-2">
            <div class="card">
              <div class="card-body">
                <div class="d-flex align-items-center mb-3">
                  <div class="avatar-xs me-3">
                      <span
                          class="
                          avatar-title
                          rounded-circle
                          bg-soft bg-primary
                          text-primary
                          font-size-18">
                        <i class="bx bx-check-shield"></i>
                      </span>
                  </div>
                  <h5 class="font-size-14 mb-0">Eficiência (%)</h5>
                </div>
                <div class="text-muted mt-4">
                  <h3>
                    {{ formatDecimal(eficEntrega) }}%
                    <i class="mdi mdi-chevron-up ms-1 text-success"></i>
                  </h3>
                  <div class="d-flex">
                      <span :class="{'font-size-12 badge-soft-success': eficEntregAnt >= 0, 'font-size-12 badge-soft-warning': eficEntregAnt < 0}"
                      >{{ eficEntregAnt >=0 ? "+" : ""}} {{ formatDecimal(eficEntregAnt) }}%</span
                      >
                    <span class="ms-2 text-truncate">do período anterior</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <div class="card">
              <div class="card-body">
                <div class="d-flex align-items-center mb-3">
                  <div class="avatar-xs me-3">
                      <span
                          class="
                          avatar-title
                          rounded-circle
                          bg-soft bg-primary
                          text-primary
                          font-size-18">
                        <i class="bx bx-archive-in"></i>
                      </span>
                  </div>
                  <h5 class="font-size-14 mb-0">Custo Frete Mês</h5>
                </div>
                <div class="text-muted mt-4">
                  <h3>
                    R$ {{ formatDecimal(custoFrete) }}
                    <i class="mdi mdi-chevron-up ms-1 text-success"></i>
                  </h3>
                  <div class="d-flex">
                      <span :class="{'font-size-12 badge-soft-success ': percCustoFrete >= 0, 'font-size-12 badge-soft-warning': percCustoFrete < 0}">
                        {{ percCustoFrete >= 0 ? '+' : '' }} {{ formatDecimal(percCustoFrete) }}%</span>
                    <span class="ms-2 text-truncate">do período anterior</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <div class="card">
              <div class="card-body">
                <div class="d-flex align-items-center mb-3">
                  <div class="avatar-xs me-3">
                      <span
                          class="
                          avatar-title
                          rounded-circle
                          bg-soft bg-primary
                          text-primary
                          font-size-18
                        "
                      >
                        <i class="bx bx-purchase-tag-alt"></i>
                      </span>
                  </div>
                  <h5 class="font-size-14 mb-0">Ticket Médio</h5>
                </div>
                <div class="text-muted mt-4">
                  <h3>
                    R$ {{ formatDecimal(ticketMedio) }}
                    <i class="mdi mdi-chevron-up ms-1 text-success"></i>
                  </h3>

                  <div class="d-flex">
                      <span :class="{'font-size-12 badge-soft-success': percTicketM >= 0, 'font-size-12 badge-soft-warning': percTicketM < 0}">
                        {{ percTicketM >=0 ? "+" : ""}} {{ formatDecimal(percTicketM) }}%</span>
                    <span class="ms-2 text-truncate">do período anterior</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Loader class="mt-4" v-if="updating" style="min-height: 380px;">
    </Loader>

    <div class="row" v-if="!updating">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body" style="margin-bottom: 100px;">

            <div class="d-flex flex-wrap">
              <div class="me-2">
                <h3 class="text-muted mb-4">Análise de Status</h3>
              </div>
              <b-button
                  variant="outline-primary"
                  class="mx-2 ms-auto"
                  size="sm"
                  @click="exportExcel"
              >
                Exportar Excel <i class="bx bx-archive-out"></i>
              </b-button>
            </div>

            <div class="d-flex flex-wrap col-12">
              <!-- Codigo com os status comados comentado, solicitação em chamado 1531-->
              <!-- <div class="row col-6 mb-0" style="margin-left: 10px; margin-right: 40px">
                <div v-for="(quantidade, ocorrencia) in ocorrenciaSum" :key="ocorrencia" class="col-md-4">
                  <ul class="ps-0 mb-1">
                    <li class="ps-0 mb-1" :style="{ 'list-style-type': 'none' }">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <i class="mdi mdi-circle text-info me-1 font-size-10"></i>
                            <a class="font-weight-semibold font-size-14">{{ ocorrencia }}: </a>
                        </div>
                        <div class="d-inline" :style="{ 'margin-right': '20px' }">
                            <a
                                class="badge"
                                :class="{
                                    'badge-soft-success': ocorrencia === 'ENTREGUE NO PRAZO',
                                    'badge-soft-danger': ocorrencia === 'ENTREGUE COM ATRASO',
                                    'badge-soft-info': ocorrencia !== 'ENTREGUE NO PRAZO' && ocorrencia !== 'ENTREGUE COM ATRASO'
                                }"
                                style="min-width: 6ch; font-size: 16px; padding: 6px 12px;" >
                                {{ quantidade }}
                            </a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <br><br><br><br> <div class="mt-4 text-end">
                  <button class="dropdown-item text-primary text-center"
                    @click="exportExcel"
                    href="javascript: void(0);"
                    style="border: 1px solid black;"> Exportar Excel <i class="bx bx-archive-out"></i>
                  </button>
                </div>
              </div>-->

              <div class="justify-content-end col-5 ms-3">

                <h5 class="mb-4">Mercadoria Entregue Dentro/Fora do Prazo</h5>
                <div class="row">
                  <div class="col-sm-7" style="margin-left: 280px">
                    <apexchart
                        v-if="chartFretePrazo !== null && chartFretePrazo.series !== null"
                        class="apex-charts"
                        dir="ltr"
                        height="280"
                        :series="chartFretePrazo.series"
                        :options="chartFretePrazo.chartOptions"
                    ></apexchart>
                  </div>

                  <div class="text-center text-muted" style="position: absolute; margin-left: 0px">
                    <div class="row">
                      <div class="col-12">
                        <div class="mt-2">
                          <div class="d-flex col-8" >
                            <i class="mdi mdi-circle text-info me-1"></i>
                            <p class="mb-2 text-truncate font-size-14 font-weight-semibold"> Dentro do Prazo (Entregue)</p>
                          </div>
                          <div class="d-flex col-4 ms-3">
                            <p class="mb-1" ><a class="badge badge-soft-info font-size-13">
                              {{ formatInteger(dentroPrazo)}} NF's / R$ {{ formatDecimal(dentroPrazoValor) }} </a></p>
                          </div>
                        </div>
                        <div class="mt-2">
                          <div class="d-flex col-8">
                            <i class="mdi mdi-circle text-warning me-1"></i>
                            <p class="mb-2 text-truncate font-size-14 font-weight-semibold"> Fora do Prazo (Entregue)</p>
                          </div>
                          <div class="d-flex col-4 ms-3">
                            <p class="mb-1" ><a class="badge badge-soft-warning font-size-13">
                              {{ formatInteger(foraPrazo)}} NF's / R$ {{ formatDecimal(foraPrazoValor) }} </a></p>
                          </div>
                        </div>
                        <div class="mt-2">
                          <div class="d-flex col-8">
                            <i class="mdi mdi-circle text-success me-1"></i>
                            <p class="mb-2 text-truncate font-size-14 font-weight-semibold"> Dentro do Prazo(Em Trânsito) </p>
                          </div>
                          <div class="d-flex col-4 ms-3">
                            <p class="mb-1"><a class="badge badge-soft-success font-size-13">
                              {{ formatInteger(dentroPrazoNaoEntregue)}} NF's / R$ {{ formatDecimal(dentroPrazoNaoEntregueValor) }} </a></p>
                          </div>
                        </div>
                        <div class="mt-2">
                          <div class="d-flex col-8">
                            <i class="mdi mdi-circle text-danger me-1"></i>
                            <p class="mb-2 text-truncate font-size-14 font-weight-semibold"> Fora do Prazo(Em Trânsito) </p>
                          </div>
                          <div class="d-flex col-4 ms-3">
                            <p class="mb-1"><a class="badge badge-soft-danger font-size-13">
                              {{ formatInteger(foraPrazoNaoEntregue)}} NF's / R$ {{ formatDecimal(foraPrazoNaoEntregueValor) }} </a></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-1 " style="float:left; max-width:360px;max-height:360px;margin-right:-80px; border-left:1px solid #c5c6ca" ></div>

              <div class="justify-content-end col-5 ms-3">

                <div class="d-flex flex-wrap">
                  <div class="me-2 mb-1 mt-2">
                    <h5 class="mb-3">SLA Top 5 Estados</h5>
                  </div>
                </div>
                <hr/>

                <ul class="list-group list-group-flush">
                  <div v-for="(data, index) of slaTopCincoEstados" :key="index">
                    <li class="list-group-item">
                      <div class="py-2">
                        <h5 class="font-size-13">
                          {{ nomeUF(data.destestado) }} <span class="float-end">{{ formatDecimal(data.sla_percentual) }}</span>
                        </h5>
                        <div class="progress animated-progess progress-sm">
                          <div
                              class="progress-bar"
                              :class="'progress-bar ' + data.style"
                              role="progressbar"
                              :style="'width: ' + data.perc + '%'"
                              :aria-valuenow="data.perc"
                              aria-valuemin="0"
                              aria-valuemax="100"
                          ></div>
                        </div>
                      </div>
                    </li>
                  </div>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Loader class="mt-4" v-if="updating" style="min-height: 100px;">
    </Loader>

    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>



    <b-modal v-model="showModalBoasVindas" centered hide-footer @hide="ofereceUpdate">

      <div class="row justify-content-center">
        <div class="col-md-12">
          <div class="card overflow-hidden">
            <div class="bg-soft bg-primary">
              <div class="row">
                <div class="col-7">
                  <div class="text-primary p-4">
                    <h5 class="text-primary">Primeiros passos</h5>
                    <p>Insira sua tabela ou token e em seguida realize suas cotações.</p>
                  </div>
                </div>
                <div class="col-5 align-self-end">
                  <img
                      src="@/assets/images/profile-img.png"
                      alt
                      class="img-fluid"
                  />
                </div>
              </div>
            </div>
            <div class="card-body pt-0">
              <div>
                <router-link to="/">
                  <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo.svg" alt height="34" />
                  </span>
                  </div>
                </router-link>
              </div>

              <b-form class="p-2" @submit.prevent="naoExibirBoasVindas">


                <div class="mt-5 mb-5 text-center">
                  <p>
                    Inserir informações corporativas
                  </p>
                  <i class="mdi mdi-link text-danger">
                    <router-link :to="'/usuario/perfil/' + userLogged.id" class="fw-medium text-primary" target="_blank">
                      Minha Empresa
                    </router-link>
                  </i>
                </div>


                <div class="mt-5 mb-5 text-center">
                  <p>
                    Inserir ou importar minhas tabelas de cotação
                  </p>
                  <i class="mdi mdi-link text-info">
                    <router-link to="/cotacaofretesbase/list" class="fw-medium text-primary" target="_blank">
                      Tabelas de Cotação
                    </router-link>
                  </i>
                </div>

                <div class="mt-5 mb-5 text-center">
                  <p>
                    Inserir meus tokens de cotação
                  </p>
                  <i class="mdi mdi-link text-warning">
                    <router-link :to="'/usuario/perfil/' + userLogged.id" class="fw-medium text-primary" target="_blank">
                      Meu Perfil
                    </router-link>
                  </i>
                </div>

                <div class="mt-5 mb-5 text-center">
                  <p>
                    Realizar cotação de fretes
                  </p>
                  <i class="mdi mdi-link text-success">
                    <router-link to="/cotafrts/listnova" class="fw-medium text-primary" target="_blank">
                      Listar Cotações
                    </router-link>
                  </i>
                </div>

              </b-form>
            </div>

          </div>


        </div>
      </div>


      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalBoasVindas = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button variant="outline-warning" class="ms-1" @click="naoExibirBoasVindas">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Não Exibir Novamente
        </b-button>
      </div>
    </b-modal>


    <b-modal  size="xl"
              title="Escolha o plano de acordo com sua necessidade" v-model="showModalUpgradePlano" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">

            <b-row>
              <div v-for="data in planosData" :key="data.valor" class="col-xl-3 col-md-6">
                <div class="card plan-box">
                  <div class="card-body p-4">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <h5>{{data.nome}}</h5>
                        <p class="text-muted">{{data.text}}</p>
                      </div>
                      <div class="ms-3">
                        <i :class="`bx ${data.icon} h1 text-primary`"></i>
                      </div>
                    </div>
                    <div class="py-4" v-if="data.nome === 'TMS Pro'">
                      <h2>

                        {{data.valor}}

                      </h2>
                    </div>
                    <div class="py-4" v-else>
                      <h2>
                        <sup>
                          <small>R$ </small>
                        </sup>
                        {{data.valor}}/
                        <span class="font-size-13">Mensal</span>
                      </h2>
                    </div>
                    <div class="text-center plan-btn" v-if="data.nome === 'TMS Pro'">
                      <b-button :disabled="data.id === 'tms_free'"  class="btn btn-success btn-sm position-relative" @click="upgradePlano()">
                        Falar com Consultor
                      </b-button>
                    </div>
                    <div class="text-center plan-btn" v-else>
                      <b-button :disabled="data.id === 'tms_free'"  class="btn btn-success btn-sm position-relative" @click="upgradePlano()">
                        Assinar Agora
                      </b-button>
                    </div>
                    <div class="mt-3"></div>
                    <div class="plan-features mt-0" v-for="(item, index) in data.itens" :key="index">
                      <p>
                        <i class="bx bx-checkbox-square text-primary me-2"></i> {{ item }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </b-row>

          </div>
        </div>
      </div>
    </b-modal>


    <b-modal 
      size="lg"
      title="Bem vindo!"
      v-model="showFormModal" 
      centered hide-footer
      no-close-on-backdrop 
      no-close-on-esc
      hide-header-close
    >
      <div>
        <h6>
          Por favor, preencher o formulário para melhorarmos nosso atendimento!
          ({{ formIndex + 1 }}/{{ formData.length }})
        </h6>
        <span
          v-if="formDeny"
          class="text-danger"
        >
          Voce deve responder para continuar!
        </span>
        <hr>

        <b-label class="mt-4 fw-bold">{{ formData[formIndex].label }}</b-label> 
        <b-form-checkbox
          v-for="(option, index) in formData[formIndex].options"
          :id="option + index"
          :key="index"
          :value="option"
          :checked="formData[formIndex].value === option"
          v-model="formData[formIndex].value"
          @click="formDeny = false"
        >
          {{ option }}
        </b-form-checkbox>
        <div v-if="formData[formIndex].value === 'Outro'">
          <input
            v-model="formData[formIndex].otherText"
            @focusable="formDeny = false"
            @click="formDeny = false"
            type="text"
            :class="{
              'form-control': true, 
              'mt-2': true,
              'border-danger': formDeny
            }"
            aria-describedby="helpId"
            placeholder="Escreva aqui"
          />
          <span
            v-if="formDeny"
            class="text-danger"
          >
            Preencha o campo para continuar!
          </span>
        </div>
      </div>
      <div class="d-flex justify-content-center gap-4 mt-4">
        <b-button
          v-if="formIndex > 0"
          variant="outline-danger"
          class="mt-4"
          @click="formIndex -= 1; formDeny = false"
        >
          Voltar
        </b-button>
        <b-button
          v-if="formIndex < formData.length - 1   "
          variant="outline-success"
          class="float-right mt-4 ml-auto"
          @click="nextQuestion"
        >
          Proxima
        </b-button>
        <b-button
          v-if="formIndex === formData.length - 1"
          variant="outline-success"
          class="float-right mt-4"
          @click="sendRegisterForm"
        >
          Enviar formulario
        </b-button>
      </div>
    </b-modal>
  </Layout>
</template>
